import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManagerReportsDetailPageRoutingModule } from './manager-reports-detail-routing.module';

import { ManagerReportsDetailPage } from './manager-reports-detail.page';
import { TranslateModule } from '@ngx-translate/core';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    SharedComponentsModule,
    ManagerReportsDetailPageRoutingModule
  ],
  declarations: [ManagerReportsDetailPage]
})
export class ManagerReportsDetailPageModule {}
